<template>
    <div>
        <div v-if="!isLoading" class="row gy-2">
            <div v-if="item" class="col-12">
                <div class="row g-4">
                    <div class="col-md-12">
                        <div class="card mb-4 overflow-hidden">
                            <div class="card-header d-grid gap-3 d-sm-flex justify-content-sm-between align-items-center">
                                <h5 class="card-title mb-0">Your {{ $filters.monthNumberToName(item.month) }} {{ item.year }} Payroll Details </h5>
                                <button @click="printPayslip()" class="btn btn-sm btn-outline-primary"> Print Pay slip</button>
                            </div>
                            <div class="card-body">
                                <div class="row g-4">
                                    <div class="col-12">
                                        <div class="row g-3">
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Status</label>
                                                <h6 class="mb-0">
                                                    <span v-html="statusBadge(item.status)"></span>
                                                </h6>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Basic salary</label>
                                                <h6 class="mb-0">{{ $filters.money_format(item.basic_salary,
                                                    2) }}
                                                </h6>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Total Monthly Allowances</label>
                                                <h6 class="mb-0">{{ $filters.money_format(item.total_allowances, 2) }}
                                                </h6>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Total Monthly Deductions</label>
                                                <h6 class="mb-0">{{
                                                    $filters.money_format(item.total_deductions, 2) }}
                                                </h6>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Monthly Gross pay</label>
                                                <h6 class="mb-0">{{ $filters.money_format(item.gross_pay, 2)
                                                    }}</h6>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Monthly Net pay</label>
                                                <h6 class="mb-0">{{ $filters.money_format(item.net_pay, 2) }}
                                                </h6>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Tax</label>
                                                <h6 class="mb-0">{{
                                                    $filters.money_format(item.tax, 2) }}
                                                </h6>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">NHF</label>
                                                <h6 class="mb-0">{{ $filters.money_format(item.nhf, 2)
                                                    }}</h6>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">SHIS</label>
                                                <h6 class="mb-0">{{ $filters.money_format(item.shis, 2)
                                                    }}</h6>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Arrears</label>
                                                <h6 class="mb-0">{{
                                                    $filters.money_format(item.arrears, 2) }}
                                                </h6>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Refunds</label>
                                                <h6 class="mb-0">{{ $filters.money_format(item.refunds, 2)
                                                    }}</h6>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Loans</label>
                                                <h6 class="mb-0">{{ $filters.money_format(item.total_loans, 2) }}
                                                </h6>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Contributions</label>
                                                <h6 class="mb-0">{{ $filters.money_format(item.contributions, 2) }}
                                                </h6>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Union Dues</label>
                                                <h6 class="mb-0">{{ $filters.money_format(item.union_dues, 2) }}
                                                </h6>
                                            </div>
                                             <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Payroll Month</label>
                                                <h6 class="mb-0">{{ $filters.monthNumberToName(item.month) }} {{ item.year }}
                                                </h6>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row g-3">
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Salary Structure</label>
                                                <h6 v-if="item.salary_structure" class="mb-0">
                                                    {{ item.salary_structure.title }}
                                                </h6>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Grade Level</label>
                                                <h6 v-if="item.grade_level" class="mb-0">
                                                    {{ item.grade_level.title }}
                                                </h6>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Step Level</label>
                                                <h6 v-if="item.step_level" class="mb-0">
                                                    {{ item.step_level.title }}
                                                </h6>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row g-3">
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Civil service</label>
                                                <h6 v-if="item.civil_service" class="mb-0">
                                                    {{ item.civil_service.title }}
                                                </h6>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">MDA</label>
                                                <h6 v-if="item.ministry" class="mb-0">
                                                    {{ item.ministry.name }}
                                                </h6>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <label class="small text-muted">Department</label>
                                                <h6 v-if="item.department" class="mb-0">
                                                    {{ item.department.name }}
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row g-3">
                    <div class="col-md-6">
                        <div class="card">
                            <div class="card-header">
                                <h6 class="card-header-title m-0">Payroll Allowances</h6>
                            </div>
                            <div class="card-body">
                                <ol class="ps-3" v-if="item.allowances.length">
                                    <li v-for="item in item.allowances" :key="item.id" class="mb-2">
                                        <p class="mb-1">
                                            <span v-if="item.category">{{ item.category.title }}</span>
                                            <span v-else> Unknown Allowance</span>
                                            - <strong>{{ $filters.money_format(item.amount, 2) }}</strong></p>
                                    </li>
                                </ol>
                                <p v-else class="mb-0">No allowances to show</p>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.loan_repayments.length" class="col-md-6">
                        <div class="card">
                            <div class="card-header">
                                <h6 class="card-header-title m-0">Loan(s)</h6>
                            </div>
                            <div class="card-body">
                                <ol class="ps-3">
                                    <li v-for="item in item.loan_repayments" :key="item.id" class="mb-2">
                                        <p class="mb-1"><span v-if="item.loan"><span v-if="item.loan.lender">{{ item.loan.lender.name }}</span></span>
                                        - <strong> {{ $filters.money_format(item.amount, 2) }}</strong></p>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.union_dues_payments.length" class="col-md-6">
                        <div class="card">
                            <div class="card-header">
                                <h6 class="card-header-title m-0">Union Dues</h6>
                            </div>
                            <div class="card-body">
                                <ol class="ps-3">
                                    <li v-for="item in item.union_dues_payments" :key="item.id" class="mb-2">
                                        <p class="mb-1"><span v-if="item.labour_union">{{ item.labour_union.name }}</span>
                                        - <strong> {{ $filters.money_format(item.amount, 2) }}</strong></p>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                     <div v-if="item.contribution_payments.length" class="col-md-6">
                        <div class="card">
                            <div class="card-header">
                                <h6 class="card-header-title m-0">Contribution(s)</h6>
                            </div>
                            <div class="card-body">
                                <ol class="ps-3">
                                    <li v-for="item in item.contribution_payments" :key="item.id" class="mb-2">
                                        <p class="mb-1"><span v-if="item.contribution"><span v-if="item.contribution.group">{{ item.contribution.group.name }}</span></span>
                                        - <strong> {{ $filters.money_format(item.amount, 2) }}</strong></p>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.arrear_payments.length" class="col-md-6">
                        <div class="card">
                            <div class="card-header">
                                <h6 class="card-header-title m-0">Arrear(s)</h6>
                            </div>
                            <div class="card-body">
                                <ol class="ps-3">
                                     <li v-for="item in item.arrear_payments" :key="item.id" class="mb-2">
                                        <p class="mb-1">
                                            <span v-if="item.category">{{ item.category.title }}</span>
                                            <span v-else> Unknown Arrears</span>
                                            - <strong>{{ $filters.money_format(item.amount, 2) }}</strong></p>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.refund_payments.length" class="col-md-6">
                        <div class="card">
                            <div class="card-header">
                                <h6 class="card-header-title m-0">Refund(s)</h6>
                            </div>
                            <div class="card-body">
                                <ol class="ps-3">
                                     <li v-for="item in item.refund_payments" :key="item.id" class="mb-2">
                                        <p class="mb-1">
                                            <span v-if="item.category">{{ item.category.title }}</span>
                                            <span v-else> Unknown Refund</span>
                                            - <strong>{{ $filters.money_format(item.amount, 2) }}</strong></p>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <CommonSpinner v-else />
    </div>
</template>

<script>

export default {
    name: "payroll-show",
    components: {
    },
    props: {
        quickView: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            isLoading: true,
            popupModalShow: false,
            popupModalStatus: false,
            item: null,
        }
    },
    watch: {
        '$route.params.payrollId': function (id) {
            if (id) this.fetchItem()
        },
    },
    methods: {
        updateItem(item) {
            Object.assign(this.item, item)
        },
        fetchItem() {
            this.isLoading = true
            this.$http.get(`/payrolls/${this.quickView ? this.quickView.id : this.$route.params.payrollId}/show`)
                .then((response) => {
                    this.isLoading = false
                    if (response.data.success) {
                        this.item = response.data.data
                    } else {
                        this.$router.push({ path: '/error-404' })
                    }
                })
        },
        printPayslip() {
            const payload = {
                url: `/payrolls/${this.item.id}/print-slip`,
                data: {}
            }
            this.$store.dispatch("changeLoaderValue", true)
            this.pdfFileExport(payload)
                .then((response) => {
                    this.$store.dispatch("changeLoaderValue", false)
                }).catch((error) => {
                    this.$store.dispatch("changeLoaderValue", false)
                })

        },
        initializeAll() {
            this.popupModalShow = false;
            this.popupModalStatus = false;
        }
    },
    created() {
        this.fetchItem()
    },
}

</script>
